import { EditOutlined } from '@ant-design/icons';
import { type RootState } from '@reducers';
import { Button, Form, Input, Space } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { propertyAdd } from '../../reducers/properties/reducer';
import { SPACING } from '../../theme/tokens';
import Link from '../link';

interface IForm {
  code: string;
}

function PropertyAdd(): React.ReactElement {
  const dispatch = useAppDispatch();
  const propertiesInProcess = useSelector(
    (s: RootState) => s.Properties.inProcess,
  );
  const propertyCode = useSelector(
    (s: RootState) => s.Properties.property.code,
  );

  const [form] = Form.useForm<IForm>();
  const [newPropertyElement, setNewPropertyElement] = useState<
    React.ReactElement | undefined
  >(undefined);

  const onFinish = useCallback(
    ({ code }: IForm): void => {
      dispatch(propertyAdd(code));
    },
    [dispatch],
  );

  useEffect((): void => {
    if (propertiesInProcess === false && propertyCode === undefined) {
      form.resetFields();
    }
  }, [propertiesInProcess, propertyCode, form]);

  useEffect((): void => {
    let newPropertyElementUE: React.ReactElement | undefined;

    if (propertyCode) {
      newPropertyElementUE = (
        <Link
          to={`/property/${propertyCode}`}
          openInNewTab
          label={`Created new property ${propertyCode}`}
        />
      );
    }

    setNewPropertyElement(newPropertyElementUE || undefined);
  }, [propertyCode]);

  return (
    <Space size={SPACING.lg} align="start">
      <Form form={form} onFinish={(values: IForm): void => onFinish(values)}>
        <Form.Item
          name="code"
          rules={[
            {
              required: true,
            },
            {
              type: 'string',
              min: 3,
            },
          ]}
          label="Property CODE"
        >
          <Input
            size="large"
            placeholder="Create new property CODE"
            prefix={<EditOutlined />}
            type="string"
            disabled={propertiesInProcess}
          />
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form>

      {newPropertyElement}
    </Space>
  );
}

export default PropertyAdd;
